module.exports = __webpack_public_path__ + "img/huayi.406f90c0.jpg";